import NavigationBar from "components/shared/NavigationBar";

function Page({
  className = "",
  childrenClassName = "flex-1 flex flex-col overflow-auto relative",
  leftButtons,
  rightButtons,
  backTo,
  title,
  subtitle = null,
  prompt,
  staticHeader = true,
  children,
  testing,
  testingMessage = "We are testing this page. If you have any feedback, please contact us.",
  ...rest
}) {
  return (
    <div
      id="page"
      className={`flex flex-col flex-1 min-h-screen ${className}`}
      {...rest}
    >
      <NavigationBar
        leftButtons={leftButtons}
        rightButtons={rightButtons}
        backTo={backTo}
        title={title}
        subtitle={subtitle}
        prompt={prompt}
        testing={testing}
        testingMessage={testingMessage}
      />

      <div className={childrenClassName}>{children}</div>
    </div>
  );
}

export default Page;
